export default "__VITE_ASSET__4901164d__"